<template>
  <div class="content">
    <n-card :more="true" title="Skill Cloud">
      <div class="chart-worldcloud-box">
        <!-- <ve-histogram :data="chartData" :settings="chartSetting" /> -->
        <ve-wordcloud :data="chartData" :settings="chartSettings"></ve-wordcloud>
      </div>
    </n-card>
  </div>
</template>
<script>
import nCard from "@/components/profile/nCard.vue";
import VeHistogram from "v-charts/lib/histogram.common";
import VeWordcloud from "v-charts/lib/wordcloud.common";
export default {
  components: {
    nCard,
    VeHistogram,
    VeWordcloud
  },
  data() {
    return {
      avater: "",
      name: "John Doe",
      phone: "456123456",
      level: "Sannifor nia",
      mail: "jonge@ddcs.tv",
      points: 250,
      chartData: {
        columns: ["word", "point"],
        rows: [
          {word: "JavaScript",point: 60000},
          {word: "前端",point: 39000},
          {word: "Web",point: 38720},
          {word: "VUE",point: 29998},
          {word: "JSON",point: 29977},
          {word: "NODE",point: 28877},
          {word: "Ajax",point: 27747},
          {word: "JQuery",point: 27456},
          {word: "Hbuilder",point: 24520},
          {word: "Git",point: 21230},
          {word: "HTML",point: 21252},
          {word: "CSS3",point: 20802},
          {word: "uniapp",point: 18130},
          {word: "微信小程序",point: 16520},
          {word: "后端",point: 16400},
          {word: "JAVA",point: 16300},
          {word: "Layui",point: 16259},
          {word: "Restful",point: 13222},
          {word: "React",point: 13215},
          {word: "SpringBoot",point: 10125},
          {word: "Maven",point: 10812},
          {word: "Python",point: 8120},
          {word: "MySQL",point: 8000},
          {word: "测试",point: 7050},
          {word: "Monkey",point: 6850},
          {word: "Android",point: 6120},
          {word: "Flutter",point: 4230},
        ]
      },
      chartSettings: {
        sizeMin: 10,
        sizeMax: 80
      }
    };
  }
};
</script>
<style>
.content {
  width: 400px;
  /* min-height: 300px; */
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
.user-content {
  min-width: 250px;
  height: 200px;
  display: flex;
  padding-bottom: 25px;
}
.user-content .avatar {
  min-height: 125px;
  min-width: 125px;
}
.ivu-avatar > img {
  border-radius: 50%;
}
.left {
  min-width: 50%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.left .title {
  font-size: 20px;
}
.left .sub-title {
  font-size: 12px;
  color: #2b7cba;
}
.right-form {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.form-item {
  text-align: left;
  margin-bottom: 10px;
}
.form-item label {
  font-size: 14px;
  color: #ccc;
  display: block;
}
.form-input {
  width: auto;
  margin-right: 5px;
}
.form-input .ivu-input-suffix {
  display: none;
}
.form-item .ivu-input-with-suffix {
  padding-right: 7px;
}
.form-input input.main {
  font-weight: bold;
  font-size: 16px;
}
.form-input input::placeholder,
input::-moz-placeholder,
input::-webkit-input-placeholder {
  font-size: 14px;
  font-weight: none;
}
.form-input .ivu-input {
  border: none;
  border-bottom: 1px solid #dcdee2;
  border-radius: 0px;
  padding-left: 0;
  height: 28px;
}
.form-input .ivu-input:focus {
  /* box-shadow: 0 0 0 2px rgba(45,140,240,.2); */
  box-shadow: none;
  border-bottom: 1px solid rgba(45, 140, 240, 0.2);
  border-radius: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/profile/skill-card.vue